
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talk-direct-to-us",
      function () {
        return require("private-next-pages/talk-direct-to-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talk-direct-to-us"])
      });
    }
  